module.exports = __webpack_public_path__ + "static/media/359.44565eee.svg";